<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
const sportsImgDesktopSrc = cfgToThemeCdnPath("/about-vip/modern/sportsbook-categories.png");
const sportsImgMobileSrc = cfgToThemeCdnPath("/about-vip/modern/sportsbook-categories-mobile.png");
const sportsImgSrc = $derived($isMobile ? sportsImgMobileSrc : sportsImgDesktopSrc);
const cardGlowTransform = $derived($isMobile ? "translate(-50%, 50%)" : "");
const cardGlowSize = $derived($isMobile ? "100%" : "");
</script>

<section class="vip-sportsbook">
	<VipModernEyebrow text={$t(Verbiage.sportsbook)} />

	<Text
		type="title"
		titleSize="h4"
		titleWeight="bold"
		textColor="white"
		textAlign={$isMobile ? 'start' : 'center'}
		className="vip-sportsbook-title"
	>
		{$t(Verbiage.vip_modern_what_about_sportsbook)}
	</Text>

	<InfoCard
		modernStyle
		modernBordered={false}
		modernGlowPosition="left"
		modernGlowTransform={cardGlowTransform}
		modernGlowSize={cardGlowSize}
		width="100%"
		noPadding
		borderRadius="20px"
		customClass="vip-sportsbook-card"
	>
		<div class="vip-sportsbook-inner">
			<img
				class="vip-sportsbook-img"
				src={sportsImgSrc}
				alt={$t(Verbiage.illustration_alt, 'alts')}
			/>

			<div class="vip-sportsbook-content">
				<span class="vip-sportsbook-badge">{$t(Verbiage.vip_modern_premium_betting)}</span>

				<div class="vip-sportsbook-body">
					<Text type="body" bodySize="large" textColor="white">
						{$t(Verbiage.vip_modern_sportsbook_body1)}
					</Text>
					<Text type="body" bodySize="large" textColor="white">
						{$t(Verbiage.vip_modern_sportsbook_body2)}
					</Text>
				</div>

				<InfoCard
					modernStyle
					modernGlowPosition="left"
					noPadding
					borderRadius="8px"
					customClass="vip-sportsbook-note"
				>
					<div class="vip-sportsbook-note-inner">
						<span class="vip-sportsbook-note-icon">
							<span class="vip-sportsbook-dot"></span>
						</span>
						<Text type="body" bodySize="small" textColor="white">
							{$t(Verbiage.vip_modern_sportsbook_note)}
						</Text>
					</div>
				</InfoCard>
			</div>
		</div>
	</InfoCard>
</section>

<style>
	.vip-sportsbook {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: flex-start;
		gap: 1.25rem;
		text-align: left;
}

	:global(.vip-sportsbook-title) {
		font-size: 32px !important;
}

	:global(.vip-sportsbook-card) {
		position: relative;
		margin-top: 1.5rem;
		width: 100%;
		overflow: hidden;
}

	:global(.vip-sportsbook-card .info-card-modern.glow-left::before) {
		top: auto;
		bottom: 0;
	}

	.vip-sportsbook-inner {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
}

	.vip-sportsbook-content {
		position: relative;
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 1rem;
		padding: 1.5rem;
		text-align: left;
}

	.vip-sportsbook-badge {
		display: inline-block;
		width: -moz-fit-content;
		width: fit-content;
		white-space: nowrap;
		font-size: 0.75rem;
		line-height: 1rem;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.025em;
		background-color: rgb(255 255 255 / 0.05);
		color: var(--color-primary-300);
		border-radius: 9999px;
		padding-left: 0.75rem;
		padding-right: 0.75rem;
		padding-top: 0.375rem;
		padding-bottom: 0.375rem;
}

	.vip-sportsbook-body {
		display: flex;
		max-width: 22rem;
		flex-direction: column;
		gap: 0.25rem;
}

	:global(.vip-sportsbook-note) {
		width: 100%;
		max-width: 22rem;
}

	.vip-sportsbook-note-inner {
		display: flex;
		width: 100%;
		align-items: flex-start;
		gap: 0.75rem;
		padding: 1rem;
}

	.vip-sportsbook-note-icon {
		margin-top: 0.25rem;
		display: flex;
		flex-shrink: 0;
		flex-direction: column;
		align-items: center;
		gap: 0.25rem;
}

	.vip-sportsbook-dot {
		display: block;
		height: 0.375rem;
		width: 0.375rem;
		border-radius: 9999px;
		background-color: var(--color-highlight-3);
		--tw-shadow: 0 0 6px 1px var(--color-highlight-3);
		--tw-shadow-colored: 0 0 6px 1px var(--tw-shadow-color);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

	.vip-sportsbook-img {
		position: relative;
		height: auto;
		width: 100%;
		-o-object-fit: contain;
		   object-fit: contain;
}

	@media (min-width: 1024px) {
		:global(.vip-sportsbook-title) {
				font-size: 37px !important;
		}

		.vip-sportsbook {
				align-items: center;
				text-align: center;
		}

		:global(.vip-sportsbook-card) {
				height: 340px;
		}

		.vip-sportsbook-content {
				width: 50%;
				padding: 2.5rem;
		}

		.vip-sportsbook-img {
				position: absolute;
				top: 0px;
				right: 0px;
				z-index: 0;
				height: 100%;
				width: 50%;
				-o-object-fit: contain;
				   object-fit: contain;
		}

		:global(.vip-sportsbook-card .info-card-modern.glow-left::before) {
			top: 0;
			bottom: auto;
		}
	}
</style>
